import { FirestoreDataConverter } from "firebase/firestore";
import PosicaoAtivo from "../models/posicaoAtivo";
import BaseDb from "./baseDb";

export default class PosicaoVencidaDb extends BaseDb<
  PosicaoAtivo,
  { usuarioId: string; posicaoVencidaId: string }
> {
  _path: string = "usuarios/usuarioId/posicoesVencidas/posicaoVencidaId";
  getConverter(): FirestoreDataConverter<PosicaoAtivo> {
    return {
      fromFirestore: (snapshot, _options) =>
        PosicaoAtivo.fromFirestore(snapshot.data()),
      toFirestore: (_posicaoVencida: PosicaoAtivo) => {
        throw new Error("Não é possível criar um imposto");
      },
    };
  }
}
